import React, { memo, useCallback, useEffect, useRef, useState } from "react";
import "./AmenitiesAnalysis.css";
import { Col, Row } from "reactstrap";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { handlingCatchError } from "../../../../Utils/ErrorHandling";

import axios from "axios";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import TablePagination from "@mui/material/TablePagination";
import ArrowUp from "@mui/icons-material/ArrowUpward";
import ArrowDown from "@mui/icons-material/ArrowDownward";
import CheckCircleOutlineRoundedIcon from "@mui/icons-material/CheckCircleOutlineRounded";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import InfiniteScroll from "react-infinite-scroller";
import Tooltip from "@mui/material/Tooltip";
import Chip from "@mui/material/Chip";
import { createTheme, ThemeProvider, styled } from "@mui/material/styles";
import AdditionalLodging from '../../../../Assets/Images/icons/Additional Lodging.png';
import AttractionsDescriptions from '../../../../Assets/Images/icons/Attractions Descriptions.png';
import BeachAccess from '../../../../Assets/Images/icons/Beach Access.png';
import Cabins from '../../../../Assets/Images/icons/Cabins.png';
import Cafe from '../../../../Assets/Images/icons/Cafe.webp';
import CellphoneConnectivity from '../../../../Assets/Images/icons/Cellphone Connectivity.png';
import DumpStation from '../../../../Assets/Images/icons/Dump Station.png';
import BackIn from '../../../../Assets/Images/icons/BackIn.png';
import DogParks from '../../../../Assets/Images/icons/DogParks.png';
import LaundryAccess from '../../../../Assets/Images/icons/LaundryAccess.png';
import PullInPullThrough from '../../../../Assets/Images/icons/PullInPullThrough.png';
import SelfServiceCarWash from '../../../../Assets/Images/icons/SelfServiceCarWash.png';
import ElectricHookup from '../../../../Assets/Images/icons/Electric Hookup.png';
import FireRing from '../../../../Assets/Images/icons/Fire Ring.png';
import Fishing from '../../../../Assets/Images/icons/Fishing.png';
import GameRoomArcade from '../../../../Assets/Images/icons/GameRoom Arcade.png';
import GolfcartRentals from '../../../../Assets/Images/icons/Golfcart Rentals.png';
import Hookups from '../../../../Assets/Images/icons/Hookups.png';
import InternetConnectivity from '../../../../Assets/Images/icons/Internet Connectivity.png';
import InternetConnectivityPayment from '../../../../Assets/Images/icons/Internet Connectivity Payment.png';
import Lakeside from '../../../../Assets/Images/icons/Lake-side.png';
import OnsitePropane from '../../../../Assets/Images/icons/Onsite Propane.png';
import PetAllowed from '../../../../Assets/Images/icons/Pet Allowed.png';
import PicnicTable from '../../../../Assets/Images/icons/Picnic Table.webp';
import RecHall from '../../../../Assets/Images/icons/Rec Hall.webp';
import SewerHookup from '../../../../Assets/Images/icons/Sewer Hookup.png';
import ShowerandBathrooms from '../../../../Assets/Images/icons/Shower and Bathrooms.png';
import SiteLockers from '../../../../Assets/Images/icons/Site Lockers.png';
import SportsCourts from '../../../../Assets/Images/icons/Sports Courts.png';
import SwimmingPool from '../../../../Assets/Images/icons/Swimming Pool.png';
import TentCamping from '../../../../Assets/Images/icons/Tent Camping.png';
import VehicularAccess from '../../../../Assets/Images/icons/Vehicular Access.png';
import WaterHookup from '../../../../Assets/Images/icons/Water Hookup.png';
import GlampingImg from '../../../../Assets/Images/icons/glamping.png';
import evCharging from '../../../../Assets/Images/icons/Vehicle Charging.png';
import { apiCommonTrigger } from "../../../../Utils/apiServicehelper";
import { Config } from "../../../../Utils/Config";

let amenitiesAnalysis = [];
let amenitiesAnalysisValue = [];
let electricHookupValue = [];
let headerValue = [],
  amenitiesList = [],
  filteredList = [];

  const theme = createTheme({
    components: {
      MuiTooltip: {
        styleOverrides: {
          tooltip: {
            background: "grey"
          }
        }
      }
    }
  });

const AmenitiesAnalysis = memo((props) => {
  const [isLoading, setLoading] = useState(false);
  const [totalPage, setTotalRecords] = useState(0);
  const location = useLocation();
  const navigate = useNavigate();
  const childRef = useRef(null);
  const marketId = props && props.marketId ? props.marketId : null;
  // const marketId = localStorage.getItem("marketId")
  //   ? localStorage.getItem("marketId")
  //   : null;
  const [amenitiesDataList, setAmenitiesDataList] = useState({});
  const [profileDetails, setProfileDetails] = useState({});
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(100);
  const [orderBy, setOrderBy] = useState("profilename");
  const [orderDirection, setOrderDirection] = useState(true);
  const [isTrue, setIsTrue] = useState(true);

  // //get market details
  useEffect(() => {
    amenitiesList = [];
    filteredList = [];
    setProfileDetails({});
    setAmenitiesDataList({});
  }, []);

  //get interactive map data
  const getMarketData = async () => {
    setLoading(true);
    let inputData={page: page,
        resultsPerPage: rowsPerPage,
        orderBy: orderBy,
        orderDirection: orderDirection ? "Asc" : "Desc",
        marketId: marketId}
    await  apiCommonTrigger("post",`${Config.API_URL}/markets/market/analysis/amenities`,inputData) .then((res) => {
      setLoading(false);
      if (res.status === 200) {
        if (page === 1) {
          amenitiesList = [];
          filteredList = [];
          amenitiesAnalysis = [];
          amenitiesAnalysisValue = [];
          headerValue = [];
        }
        amenitiesList.push(res.data.amenities);
        filteredList = [];
        for (let amenityArrays of amenitiesList){
          if(amenityArrays.length){
            const fillteredArray = amenityArrays.filter((e) => e.amenities !== "electrichookup");
            filteredList.push(fillteredArray)
          }
        }

        setTotalRecords(res.data.pagination.totalpages);
        setAmenitiesDataList({
          ...amenitiesDataList,
          amenitiesDataListData: res.data,
        });
        let index;
        let storeName = [];
        filteredList.map((da) => {
          for (var i = 0; i < da.length; i++) {
            index = storeName.findIndex((object) => {
              return object.profileid === da[i].profileid;
            });
            if (index < 0) {
              storeName.push({
                profilename: da[i].profilename,
                profileid: da[i].profileid,
              });
            }
          }
        });
        setProfileDetails({ ...profileDetails, profileDetails: storeName });
      }else{
        handlingCatchError(res, navigate);
      }
    })
    .catch(err => {
      handlingCatchError(err, navigate);
    })
  };

  //get profile for selected pins
  // const setSelectedInfo = (data) => {
  //   setProfileInfo({ ...profileInfo, profileInfo: data });
  //   setProfile({ ...profile, showProfile: true });
  // };

  //move to next page of the records
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  //change the display rows per page in record
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value));
  };

  //call rvlist based on the below changes
  useEffect(() => {
    if (page === 1 || page <= totalPage) {
      getMarketData();
    }
  }, [page, orderDirection]);

  //sorting the amenities
  function sortObject(obj) {
    if (obj && obj !== null) {
      return Object.keys(obj)
        .sort()
        .reduce(function (result, key) {
          result[key] = obj[key];

          return result;
        }, {});
    }
  }


  //get amenitiesAnalysis details
  const getHeaderValues = () => {
    amenitiesAnalysis = [];
    let amenitiesDetails = amenitiesDataList.amenitiesDataListData.amenitypercentages;
    // let amenitiesDetails = sortObject(
    //   amenitiesDataList.amenitiesDataListData.amenityPercentages
    // );
    for (let i = 0; i < Object.keys(amenitiesDetails).length; i++) {
      if (
        Object.values(amenitiesDetails)[i] !== undefined &&
        Object.values(amenitiesDetails)[i] !== ""
      ) {

        const amenitiesMapping = {
          hookups: "Hookups",
          showersandbathrooms: "Shower and Bathrooms",
          dumpstation: "Dump Station",
          onsitepropane: "Onsite Propane",
          tentcamping: "Tent Camping",
          sitelockers: "Site Lockers",
          internetconnectivity: "Internet Connectivity",
          internetconnectivitypayment: "Internet Connectivity Payment",
          cellphoneconnectivity: "Cellphone Connectivity",
          lakeside: "Lake-side",
          swimmingpool: "Swimming Pool",
          fishing: "Fishing",
          rechall: "Rec Hall",
          cabins: "Cabins",
          cafe: "Cafe",
          sportscourts: "Sports Courts",
          petallowed: "Pet Allowed",
          golfcartrentals: "Golfcart Rentals",
          beachaccess: "Beach Access",
          attractionsdescriptions: "Attractions Descriptions",
          gameroomarcade: "GameRoom Arcade",
          laundryaccess: "Laundry Access",
          pullinpullthrough: "Pull In Pull Through",
          backin: "Back In",
          dogparks: "Dog Parks",
          selfservicecarwash: "Self Service Car Wash",
          eatwentyamp: "20 Amp",
          ebthirtyamp: "30 Amp",
          ecfiftyamp: "50 Amp",
          glamping: "Glamping",
          electriclevehiclecharging : "EV Charging"
        };
        
        let tableHeader = amenitiesMapping[Object.keys(amenitiesDetails)[i]] || Object.keys(amenitiesDetails)[i];        
        headerValue.push(<th>{tableHeader}</th>);
      }
    }
    //return headerValue;
  };

  const getAmeityLabel = (value) => {
    let arrayResult = [];
    if (filteredList && filteredList.length > 0) {

      const dataset = filteredList
      .map((rec) => rec.filter((amenities) => amenities.profileid === value))
      .map((x) => x.filter((s) => s.details !== null))[0];

      dataset
        .map((x) => {
          let amenityHeader = getHeaderTooltip(x.amenities);
          return arrayResult.push(
            <Chip label={amenityHeader} 
            style={{background: "transparent",
            border: "1px solid #fff",
            color: "#fff",
            lineHeight: "25px",
            fontWeight: "normal",
            fontSize: "12px",
            height: "auto",
            marginRight: "5px",
            marginTop: "2.5px",
            marginBottom: "2.5px"}}/>
          );
        });
    }
    return arrayResult;
  };

  //get tooltip headers
  const getHeaderTooltip = (value) => {

    const dynamicTextUpdate = {
      hookups: "Hookups",
      showersandbathrooms: "Shower and Bathrooms",
      dumpstation: "Dump Station",
      onsitepropane: "Onsite Propane",
      tentcamping: "Tent Camping",
      sitelockers: "Site Lockers",
      internetconnectivity: "Internet Connectivity",
      internetconnectivitypayment: "Internet Connectivity Payment",
      cellphoneconnectivity: "Cellphone Connectivity",
      lakeside: "Lake-side",
      swimmingpool: "Swimming Pool",
      fishing: "Fishing",
      rechall: "Rec Hall",
      cabins: "Cabins",
      cafe: "Cafe",
      sportscourts: "Sports Courts",
      petallowed: "Pet Allowed",
      golfcartrentals: "Golfcart Rentals",
      beachaccess: "Beach Access",
      attractionsdescriptions: "Attractions Descriptions",
      gameroomarcade: "GameRoom Arcade",
      picnictable: "Picnic Table",
      firering: "Fire Ring",
      vehicularaccess: "Vehicular Access",
      electronichookup: "Electric Hookup",
      waterhookup: "Water Hookup",
      sewerhookup: "Sewer Hookup",
      additionallodging: "Additional Lodging",
      selfservicecarwash: "Self Service Car Wash",
      dogparks: "Dog Parks",
      backin: "Back In",
      pullinpullthrough: "Pull In Pull Through",
      laundryaccess: "Laundry Access",
      ebthirtyamp: "30 Amp",
      eatwentyamp: "20 Amp",
      ecfiftyamp: "50 Amp" , 
      glamping : "Glamping",
      electriclevehiclecharging : "EV Charging"
    };

    let tableHeader = dynamicTextUpdate[value] || "";    
    return tableHeader;
  };

  const getAmenitiesAnalysisValue = () => {
    amenitiesAnalysisValue = [];
    let amenitiesDetails = sortObject(
      amenitiesDataList.amenitiesDataListData.amenitypercentages
    );

    const testArray = []
    // amenitiesAnalysisValue.push(<TableCell className="freeze" />);
    for (let i = 0; i < Object.keys(amenitiesDetails).length; i++) {
      if (
        Object.values(amenitiesDetails)[i] !== undefined &&
        Object.values(amenitiesDetails)[i] !== ""
      ) {

        testArray.push(Object.keys(amenitiesDetails)[i])
        amenitiesAnalysisValue.push(
          <TableCell>
            {" "}
            {Object.values(amenitiesDetails)[i] == "0" || Object.values(amenitiesDetails)[i] === null
              ? "-"
              : Object.values(amenitiesDetails)[i] + " %"}
          </TableCell>
        );
      }
    }
    return amenitiesAnalysisValue;
  };

  //call lazyloading
  const handleInfiniteOnLoad = () => {
    // if (page + 1 <= totalPage) {
    setPage(page + 1);
    // }
  };


  return (
    <div>
      {isLoading ? (
        <div className="loader-wrap">
          <div className="loading loading-center"></div>
        </div>
      ) : (
        ""
      )}
      <div className="display-grid">
        <div className="amenities-legend">
          <span>
            <CheckCircleOutlineRoundedIcon className="green" />
            Has the Amenity/Feature
          </span>
          <span>
            <CancelOutlinedIcon className="red" />
            Does not have the Amenity/Feature
          </span>
        </div>
        <div className="amenities-tab-table amenities-tab-table-two">
          <div className="table-height">
            <InfiniteScroll
              initialLoad={false}
              loadMore={handleInfiniteOnLoad}
              hasMore={page !== totalPage}
              threshold={20}
              useWindow={false}
            >
              <Table className="table-design">
                <TableHead>
                  <TableRow>
                    <TableCell
                      id="sort-amenities"
                      className="freeze"
                    ><span className={orderBy === "profileName" ? 'fontbold' : 'fontnormal' }  onClick={() => {
                      setOrderBy("profileName");
                        setOrderDirection(!orderDirection);
                        setPage(1);
                      }}>
                      Profile Name</span>
                       <span className={orderBy === "AmenitiesCount" ? 'fontbold' : 'fontnormal' } onClick={() => {
                         setOrderBy("AmenitiesCount");
                        setOrderDirection(!orderDirection);
                        setPage(1);
                      }}>(Total Amenities)</span>
                      {orderDirection ? <ArrowDown onClick={() => {
                      setOrderBy(orderBy);
                        setOrderDirection(!orderDirection);
                        setPage(1);
                      }} /> : <ArrowUp onClick={() => {
                      setOrderBy(orderBy);
                        setOrderDirection(!orderDirection);
                        setPage(1);
                      }} />}
                    </TableCell>
                    {/* <TableCell>Count</TableCell> */}
                    <TableCell><img src={AdditionalLodging} alt="icons" className="table-icons"/>Additional Lodging</TableCell>
                    <TableCell><img src={AttractionsDescriptions} alt="icons" className="table-icons"/>Attractions Descriptions</TableCell>
                    <TableCell><img src={BackIn} alt="icons" className="table-icons"/>Back In</TableCell>
                    <TableCell><img src={BeachAccess} alt="icons" className="table-icons"/>Beach Access </TableCell>
                    <TableCell><img src={Cabins} alt="icons" className="table-icons"/>Cabins</TableCell>
                    <TableCell><img src={Cafe} alt="icons" className="table-icons"/>Cafe</TableCell>
                    <TableCell><img src={CellphoneConnectivity} alt="icons" className="table-icons"/>Cellphone Connectivity</TableCell>
                    <TableCell><img src={DogParks} alt="icons" className="table-icons"/>Dog Parks</TableCell>
                    <TableCell><img src={DumpStation} alt="icons" className="table-icons"/>Dump Station</TableCell>
                    <TableCell style={{width: '70px'}} className="electric-hookups-values">
                    <TableRow>
                      <TableCell></TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell className="text-center">20 Amp</TableCell>
                    </TableRow>
                  </TableCell>
                  <TableCell style={{width: '100px'}} className="electric-hookups-values">
                    <TableRow>
                      <TableCell className="text-center"><img src={ElectricHookup} alt="icons" className="table-icons"/>Electric Hookup</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell className="text-center">30 Amp</TableCell>
                    </TableRow>
                  </TableCell>
                  <TableCell style={{width: '70px'}} className="electric-hookups-values">
                    <TableRow>
                      <TableCell></TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell className="text-center">50 Amp</TableCell>
                    </TableRow>
                  </TableCell>
                    <TableCell><img src={evCharging} alt="icons" className="table-icons"/>EV Charging</TableCell>
                    <TableCell><img src={FireRing} alt="icons" className="table-icons"/>Fire Ring</TableCell>
                    <TableCell><img src={Fishing} alt="icons" className="table-icons"/>Fishing</TableCell>
                    <TableCell><img src={GameRoomArcade} alt="icons" className="table-icons"/>GameRoom Arcade</TableCell>
                    <TableCell><img src={GlampingImg} alt="icons" className="table-icons"/>Glamping</TableCell>
                    <TableCell><img src={GolfcartRentals} alt="icons" className="table-icons"/>Golfcart Rentals</TableCell>
                    <TableCell><img src={Hookups} alt="icons" className="table-icons"/>Hookups</TableCell>
                    <TableCell><img src={InternetConnectivity} alt="icons" className="table-icons"/>Internet Connectivity</TableCell>
                    <TableCell><img src={InternetConnectivityPayment} alt="icons" className="table-icons"/>Internet Connectivity Payment</TableCell>
                    <TableCell><img src={Lakeside} alt="icons" className="table-icons"/>Lake-side</TableCell>
                    <TableCell><img src={LaundryAccess} alt="icons" className="table-icons"/>Laundry Access</TableCell>
                    <TableCell><img src={OnsitePropane} alt="icons" className="table-icons"/>Onsite Propane</TableCell>
                    <TableCell><img src={PetAllowed} alt="icons" className="table-icons"/>Pet Allowed</TableCell>
                    <TableCell><img src={PicnicTable} alt="icons" className="table-icons"/>Picnic Table</TableCell>
                    <TableCell><img src={PullInPullThrough} alt="icons" className="table-icons"/>Pull In Pull Through</TableCell>
                    <TableCell><img src={RecHall} alt="icons" className="table-icons"/>Rec Hall</TableCell>
                    <TableCell><img src={SelfServiceCarWash} alt="icons" className="table-icons"/>Self Service CarWash</TableCell>
                    <TableCell><img src={SewerHookup} alt="icons" className="table-icons"/>Sewer Hookup</TableCell>
                    <TableCell><img src={ShowerandBathrooms} alt="icons" className="table-icons"/>Shower and Bathrooms</TableCell>
                    <TableCell><img src={SiteLockers} alt="icons" className="table-icons"/>Site Lockers</TableCell>
                    <TableCell><img src={SportsCourts} alt="icons" className="table-icons"/>Sports Courts</TableCell>
                    <TableCell><img src={SwimmingPool} alt="icons" className="table-icons"/>Swimming Pool</TableCell>
                    <TableCell><img src={TentCamping} alt="icons" className="table-icons"/>Tent Camping</TableCell>
                    <TableCell><img src={VehicularAccess} alt="icons" className="table-icons"/>Vehicular Access</TableCell>
                    <TableCell><img src={WaterHookup} alt="icons" className="table-icons"/>Water Hookup</TableCell>
                    {amenitiesDataList &&
                    amenitiesDataList.amenitiesDataListData &&
                    amenitiesDataList.amenitiesDataListData.amenitypercentages
                      ? getHeaderValues()
                      : ""}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {/* market summary row */}
                  <TableRow>
                    <TableCell className="freeze">Market coverage</TableCell>
                    {/* <TableCell className="freeze"></TableCell> */}
                    {amenitiesDataList &&
                      amenitiesDataList.amenitiesDataListData &&
                      amenitiesDataList.amenitiesDataListData.amenitypercentages &&
                      getAmenitiesAnalysisValue()
                    }
                  </TableRow>
                  {amenitiesAnalysisValue.length === 0 && !isLoading ? (
                    <TableRow>
                      <TableCell
                        colSpan={7}
                        style={{ textAlign: "center" }}
                        className="store-no-data"
                      >
                        No records found
                      </TableCell>
                    </TableRow>
                  ) : (
                    ""
                  )}
                  {profileDetails &&
                  profileDetails.profileDetails &&
                  profileDetails.profileDetails.length > 0
                    ? profileDetails.profileDetails.map((data) => (
                        <TableRow>
                          <TableCell className="freeze">
                            {data.profilename}
                            <ThemeProvider theme={theme}>
                            <Tooltip title={getAmeityLabel(data.profileid)}>
                           <span className="fontbold"> ({filteredList &&
                            filteredList.length > 0 &&
                            filteredList.map((rec) =>
                              rec.filter(
                                  (amenities) =>
                                    amenities.profileid === data.profileid)
                                .map((untdata, indx) => {
                                 return indx === 0 ? untdata.amenitiescount : '';
                                })
                            )})
                            </span>
                            </Tooltip>
                            </ThemeProvider>
                          </TableCell>

                          {filteredList && filteredList.length > 0 && filteredList.map((rec) =>rec.filter( (amenities) => amenities.profileid === data.profileid).map((untdata) => {
                                  let header = getHeaderTooltip(untdata.amenities);
                                  return (
                                    <TableCell className="electric-hookup-values">
                                      {untdata.details !== null ? (
                                        <CheckCircleOutlineRoundedIcon
                                          titleAccess={header + " available"}
                                          className="green"
                                        />
                                      ) : (
                                        <CancelOutlinedIcon
                                          titleAccess={
                                            header + " Not available"
                                          }
                                          className="red"
                                        />
                                      )}
                                    </TableCell>
                                  );
                                })
                            )}
                        </TableRow>
                      ))
                    : null}
                </TableBody>
              </Table>
            </InfiniteScroll>
          </div>
        </div>
      </div>
    </div>
  );
});

export default AmenitiesAnalysis;
